//// filepath: d:\NwN\content-creation-frontend\src\utils\uploadUtils.js
import axios from "axios";
import AXIOS from "../services/axios";
import { addAttachment,getAttachmentsList } from "../apis/taskManagement";

// Get file token from backend
export const getFileToken = async (fileName) => {
  const response = { data: null, error: null };
  try {
    const token = localStorage.getItem("token");
    const config = {
      headers: {
        X_APP_TOKEN: process.env.REACT_APP_VIDEO_SECRECT_KEY,
        X_USER_TOKEN: "Bearer " + token,
      },
    };
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_VIDEO_PATH}/file-upload/get-token`,
      { file_name: fileName },
      config
    );
    response.data = data;
  } catch (err) {
    response.error = err;
  }
  return response;
};

// Convert data URL to Blob
export const dataURLtoBlob = (dataURL) => {
  const byteString = atob(dataURL.split(",")[1]);
  const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};
 
// Upload generated thumbnail
export const uploadGeneratedThumbnail = async (dataURL, taskId, platform) => {
  const blob = dataURLtoBlob(dataURL);

  const fileName = `video_frame_${Date.now()}.jpg`;
  const fileObj = new File([blob], fileName, { type: "image/jpeg" });

  // Get token from server
  const { data, error } = await getFileToken(fileObj.name);

  if (error || !data?.token) throw new Error("Could not get file token");

  // Chunked upload
  let chunkSize = data.next_chunk_size;
  const totalSize = fileObj.size;
  let uploadedBytes = 0;
  let chunkNum = 1;

  while (uploadedBytes < totalSize) {
    const chunk = fileObj.slice(uploadedBytes, uploadedBytes + chunkSize);
    const formData = new FormData();
    formData.append("chunk", chunk);
    formData.append("chunk_no", chunkNum);

    const res = await fetch(
      `${process.env.REACT_APP_API_VIDEO_PATH}/file-upload/upload`,
      {
        method: "POST",
        headers: { X_FILE_TOKEN: data.token },
        body: formData,
      }
    );
    if (!res.ok) throw new Error("Chunk upload failed");

    const resJson = await res.json();
    uploadedBytes += chunkSize;
    chunkSize = resJson.next_chunk_size;
    chunkNum++;
  }

  const completeRes = await fetch(
    `${process.env.REACT_APP_API_VIDEO_PATH}/file-upload/complete`,
    {
      method: "POST",
      headers: { X_FILE_TOKEN: data.token },
    }
  );
  const finalData = await completeRes.json();
  if (!finalData?.aws_file_key)
    throw new Error("Failed to finalize thumbnail upload");
  // console.log("final data : ", finalData);
  
  const initialState = {
    facebook: false,
    instagram: false,
    youtube: false,
  };
  
  const {status,message,error:addError} = await addAttachment(
    taskId,
    finalData.aws_file_key,
    platform,
    "thumbnail",
    initialState
  );
  if(addError){
    throw new Error("Failed to add attachment");
  }
  // console.log("res data : ", message);

  // const {data:approveRes} = await getAttachmentsList(taskId,"edit",message?.pk,2);
  // console.log("approve res data : ", res);
  // Return a direct link to the S3 path, or just the key if you prefer
  return message?.file_urls[0];
};
